"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Redirector {
    redirect(redirectUrl, options) {
        if (options && options.handleRedirect) {
            options.handleRedirect(redirectUrl);
        }
        else if (options && options.redirectByReplacingState) {
            window.history.replaceState({}, "", redirectUrl);
        }
        else {
            window.location.href = redirectUrl;
        }
    }
}
exports.default = Redirector;
//# sourceMappingURL=Redirector.js.map